import { mapPictureViewToPicture } from 'app/hooks/data/core/common/mapping/picture';
import { ROOM_STATUS } from 'app/typings/core/admin/rooms/enum/roomStatus';
import type { BuilderHotelRoom } from 'app/typings/core/builder/rooms';
import type { Room } from 'app/typings/rooms';

export const mapBuilderRoomToRoom = (room: BuilderHotelRoom): Room => ({
  id: room.id,
  hotelId: room.hotelId,
  categoryId: room.categoryId,
  categoryName: room.categoryName,
  name: room.name || '',
  hasPRM: room.hasPrmAccess,
  area: room.area,
  beds: room.beds.map((bed) => ({
    id: bed.id,
    categoryId: bed.categoryId,
    price: bed.price,
    included: bed.isIncluded,
  })),
  featureIds: room.roomServices.map((roomService) => roomService.id),
  pictures: room.pictures.map(mapPictureViewToPicture),
  bookingcomId: room.bookingcomId,
  bookingcomName: room.bookingcomName,
  categoryRoomCount: room.categoryRoomCount,
  status: room.status,
  published: room.status === ROOM_STATUS.PUBLISHED,
});
